import { lazy, Suspense } from 'react';
import { Config } from '../../config/config';

export const AppEnvBase = lazy(() => import('./AppEnv'));

export const AppEnvLazy = () => {
  if (Config.App.isProduction) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <AppEnvBase />
    </Suspense>
  );
};
